import React from 'react'
import Header from '../components/Header'
import { useState } from 'react'
import config from '../app-config'
import { ToastContainer } from 'react-toastify'
import notify from '../utils/IANotification'
import 'react-toastify/dist/ReactToastify.css';
import { useEffect } from 'react'
import { analyticsCollector } from '../utils/AppFunctions'
import { register as apiRegister, login as apiLogin, initiate_email_recovery, reset_password, verify_email_recovery, verify_mfa } from '../api/authAPI'
import { useNavigate } from 'react-router-dom'
import MainHeader from '../components/MainHeader'
import { useUserConfig } from '../contexts/UserConfigContext'

export default function AuthPage({ pageState }) {
  const [user, setUser] = useState("")
  const [password, setPassword] = useState("")
  const [mfaRequired, setMfaRequired] = useState(false)
  const [mfaType, setMfaType] = useState(null)
  const [mfaCode, setMfaCode] = useState("")
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [contactNumber, setContactNumber] = useState("")

  let navigate = useNavigate()
  let token = new URLSearchParams(window.location.search).get("token") || ""
  const { fetchUserConfig } = useUserConfig()

  const register = async () => {
    const { data: resData, error, message, status } = await apiRegister({
      first_name: firstName,
      last_name: lastName,
      email: email,
      contact_number: contactNumber,
      password: password,
    })
    if (error || status !== 200) {
      notify({ message: message || error, type: 'error' })
      return
    }
    window.location.href = '/auth/login'
  }

  const login = async () => {
    const { data, error, message, status } = await apiLogin({ user, password })
    if (error || status !== 200) {
      notify({ message: message || error, type: 'error' })
      return
    }

    // If server requires 2FA, show code input
    if (message === '2FA_REQUIRED') {
      setMfaRequired(true)
      setMfaType(data?.mfa_type || 'totp')
      notify({ message: 'Two-factor authentication required. Enter the code.', type: 'info' })
      return
    }

    await analyticsCollector()
    let redirect = (decodeURIComponent(new URLSearchParams(window.location.search).get("redirect") || "") || "") || data?.redirect
    await fetchUserConfig()
    navigate(redirect)
  }

  const verifyMFA = async () => {
    if (!mfaCode) return notify({ message: 'Enter the verification code', type: 'error' })
    const { data, error, message, status } = await verify_mfa({ code: mfaCode })
    if (error || status !== 200) return notify({ message: message || error, type: 'error' })
    await analyticsCollector()
    let redirect = (decodeURIComponent(new URLSearchParams(window.location.search).get("redirect") || "") || "") || data?.redirect
    await fetchUserConfig()
    
    navigate(redirect)
  }
  // window.sessionStorage.removeItem('cred_warn')
  // if (["staff", "admin"].includes(resData.account_type)) {
  //   navigate('/admin')
  // } else {
  //   navigate('/home')
  // }


  const initiateRecovery = async () => {
    const { data: resData, error, message, status } = await initiate_email_recovery({ email: user })
    if (error || status !== 200) {
      notify({ message: message || error, type: 'error' })
      return
    }
    notify({ message: message, type: 'success' })
  }

  const resetPasword = async () => {
    const token = window.location.search.split('?token=')[1]
    const { data: resData, error, message, status } = await reset_password({ password, token })
    if (error || status !== 200) {
      notify({ message: message || error, type: 'error' })
      return
    }
    notify({ message: message, type: 'success' })
    window.location.href = '/auth/login'
  }

  const verifyRecovery = async () => {
    if (pageState !== "reset") return
    if (!token && pageState === "reset") return window.location.href = "/"
    const { data: resData, error, message, status } = await verify_email_recovery({ token })
    if (error || status !== 200) {
      notify({ message: message || error, type: 'error' })
      window.location.href = '/auth/login'
    }
  }

  useEffect(() => {
    verifyRecovery()
  }, [])


  return (
    <div className=''>
      {/* <Header /> */}
      <MainHeader />
      <div>
        <ToastContainer />
        <div className='column justifyCenter items-center' style={{ width: "100%", marginTop: 40 }}>
          {pageState === "login" && <>
            <h1 className="headerText" style={{ fontWeight: "500", fontSize: 30, marginBottom: 20 }}>Log In to Your Account</h1>
            <div style={{ maxWidth: 400, width: "100%", padding: 10 }}>
              {mfaRequired && <>
                <h3 style={{ marginBottom: 8 }}>Enter two-factor code</h3>
                <div className="input-container">
                  <input type="text" placeholder="Enter code" className="text-input" style={{ marginBottom: 10 }} value={mfaCode} onChange={(e) => setMfaCode(e.target.value)} />
                </div>
                <div className="button-container" style={{ marginTop: 10 }}>
                  <button className="button" style={{ width: "100%" }} onClick={() => verifyMFA()}>Verify</button>
                </div>
                <div style={{ height: 10 }} />
              </>}
              {!mfaRequired && <>
                <div className="input-container">
                  <input type="text" placeholder="Phone Number, username or email address" className="text-input" style={{ marginBottom: 10 }} value={user} onChange={(e) => {
                    setUser(e.target.value)
                  }} />
                  <input type="password" placeholder="Password" className="text-input" style={{ marginBottom: 10 }} value={password}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        login()
                      }
                    }}
                    onChange={(e) => {
                      setPassword(e.target.value)
                    }} />
                </div>
                <button className="backgroundLess"
                  onClick={() => {
                    window.location.href = "/auth/recovery"
                  }}
                >Forgot Password</button>
                <div className="button-container" style={{ marginTop: 30 }}>
                  <button className="button" style={{ width: "100%" }}
                    onClick={() => {
                      login()
                    }}
                  >Log In</button>

                </div>
              </>}
              <p style={{ marginTop: 20, fontSize: 12 }}>{config.version}</p>
              {config.feature_flag.allow_registration_web && <>
                <div style={{ marginTop: 30 }}>
                  <p style={{
                    backgroundColor: "#ebeff3", position: "relative", translate: "transformY(-50%)", top: "50%", bottom: -17, textAlign: "center", fontSize: 12, fontWeight: "500", color: "#8e8e8e", padding: 10, width: "fit-content", margin: "auto"
                  }}>Or create an Account</p>
                  <div style={{ width: "100%", height: 0.5, backgroundColor: "black" }} />
                </div>

                <div className="button-container" style={{ marginTop: 30 }}>
                  <button className="button-cta" style={{ width: "100%", padding: "10px 20px" }}
                    onClick={() => {
                      window.location.href = "/auth/register"
                    }}
                  >Create an Account</button>
                </div>

              </>}
            </div>
          </>}

          {pageState === "register" && config.feature_flag.allow_registration_web && <>
            <h1 className="headerText" style={{ fontWeight: "500", fontSize: 30, marginBottom: 20 }}>Welcome to {config.client_app}.</h1>
            <div style={{ maxWidth: 400, width: "100%", padding: 10 }}>
              <div className="input-container">
                <div className="flex-row flex gap-4 items-center" style={{ marginBottom: 10 }}>
                  <input type="name" placeholder="First Name" className="text-input" style={{ width: "100%" }} value={firstName} onChange={(e) => {
                    setFirstName(e.target.value)
                  }} />
                  <input type="name" placeholder="Last Name" className="text-input" style={{ width: "100%" }} value={lastName} onChange={(e) => {
                    setLastName(e.target.value)
                  }} />
                </div>
                <input type="email" placeholder="Email address" className="text-input" style={{ marginBottom: 10 }} value={email} onChange={(e) => {
                  setEmail(e.target.value)
                }} />
                <input type="tel" placeholder="Phone number" className="text-input" style={{ marginBottom: 10 }} value={contactNumber} onChange={(e) => {
                  setContactNumber(e.target.value)
                }} />
                <input type="password" placeholder="Password" className="text-input" style={{ marginBottom: 10 }} value={password} onChange={(e) => {
                  setPassword(e.target.value)
                }} />
              </div>
              <div className="button-container" style={{ marginTop: 30 }}>
                <button className="button" style={{ width: "100%" }}
                  onClick={() => {
                    register()
                  }}
                >Register</button>
              </div>

              <p style={{ marginTop: 20, textAlign: "center", padding: 20 }}>By proceeding, you agree to our <span style={{ color: "blue", fontWeight: "bold" }}>Terms and Condition</span> and <span style={{ color: "blue", fontWeight: "bold" }}>Privacy Policy</span></p>

              <div style={{ marginTop: 30 }}>
                <p style={{
                  backgroundColor: "#ebeff3", position: "relative", translate: "transformY(-50%)", top: "50%", bottom: -17, textAlign: "center", fontSize: 12, fontWeight: "500", color: "#8e8e8e", padding: 10, width: "fit-content", margin: "auto"
                }}>Already have an account? Log In</p>
                <div style={{ width: "100%", height: 0.5, backgroundColor: "black" }} />
              </div>

              <div className="button-container" style={{ marginTop: 30 }}>
                <button className="button-cta" style={{ width: "100%", padding: "10px 20px" }}
                  onClick={() => {
                    window.location.href = "/auth/login"
                  }}
                >Log into your Account</button>
              </div>
            </div>
          </>}

          {pageState === "recovery" && <>
            <h1 className="headerText" style={{ fontWeight: "500", fontSize: 30, marginBottom: 20 }}>Recover your Account</h1>
            <div style={{ maxWidth: 400, width: "100%", padding: 10 }}>
              <div className="input-container">
                <input type="text" placeholder="Email address" className="text-input" style={{ marginBottom: 10 }} value={user} onChange={(e) => {
                  setUser(e.target.value)
                }} />
              </div>
              <div className="button-container" style={{ marginTop: 30 }}>
                <button className="button" style={{ width: "100%" }}
                  onClick={() => {
                    initiateRecovery()
                  }}
                >Send Recovery Link</button>
              </div>
            </div>
          </>}

          {pageState === "reset" && <>
            <h1 className="headerText" style={{ fontWeight: "500", fontSize: 30, marginBottom: 20 }}>Reset your Password</h1>
            <div style={{ maxWidth: 400, width: "100%", padding: 10 }}>
              <div className="input-container">
                <input type="password" placeholder="New Password" className="text-input" style={{ marginBottom: 10 }} value={password} onChange={(e) => {
                  setPassword(e.target.value)
                }} />
              </div>
              <div className="button-container" style={{ marginTop: 30 }}>
                <button className="button" style={{ width: "100%" }}
                  onClick={() => {
                    resetPasword()
                  }}
                >Reset Password</button>
              </div>
            </div>
          </>}
        </div>
      </div>
    </div>
  )
}
